module.exports = __webpack_public_path__ + "static/media/lettering-letter1.95a1e632.jpg";